import {register} from '@shopify/theme-sections';
import {Slideshow} from '../ui/slideshow';

register('slideshow', {
  onLoad() {
    this.namespace = `.${this.id}`;
    this.slideshow = this.container.querySelector('[data-slideshow]');
    this.instance = new Slideshow(this.slideshow);
    this.glide = this.instance.glide;
    this.glide.on('move.after', this.handleMove.bind(this));
  },

  onBlockSelect(event) {
    const target = event.target;
    const slide = target.closest('[data-index]');
    const index = slide.dataset.index;

    this.blockSwitched = true;
    this.glide.go(`=${index}`);
  },

  handleMove() {
    if (!this.blockSwitched) {
      return;
    }

    this.glide.pause();
  },

  onDeselect() {
      this.glide.play(1);
  },

  onUnload() {
    this.glide.destroy();
  },
});
